module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/DailyPrecipitation200/Kanagawa_DailyPrecipitation200_MRI_RCP85_End.png";